import { makeThemeColor, PRIMARY, SECONDARY, LIVE, TERTIARY } from '@tornado-rdk/theme';
import { identity } from '../../../../tornado/utils/sizes';
import { makeDefaultStylingContext } from '../../../../tornado/utils/style';

export const defaultContext = makeDefaultStylingContext();

export const colors = {
  background: makeThemeColor(PRIMARY, 0.3),
  progress: makeThemeColor(SECONDARY),
  live: makeThemeColor(LIVE),
  darkLive: makeThemeColor(TERTIARY, 0.6),
};

export const getInitialStyle = (context = defaultContext) => ({
  color: colors.background[context.colorMode],
  PlayHeadBar: {
    h: identity,
    w: identity,
    pivotX: 0,
    color: colors.live[context.colorMode],
  },
  PlayHeadBarOverlay: {
    h: identity,
    w: identity,
    pivotX: 0,
    color: colors.darkLive[context.colorMode],
  },
  ProgressBar: {
    h: identity,
    w: identity,
    pivotX: 0,
  },
});
